import PropTypes from 'prop-types';

Distance.propTypes = {
  distance: PropTypes.number,
};

export default function Distance({distance}) {
    return <span>{distance || distance === 0 ? `${distance}km` : '-'}</span>;
}
